import { ModuleRoute } from 'module-routes';

export enum ReportPath {
  SalesPeriod = 'sales-period',
  ProductExpiration = 'product-expiration',
  TopSellingProducts = 'top-selling-products',
  StockReplenishment = 'stock-replenishment',
  AccountsReceivable = 'accounts-receivable',
}

export const ReportModuleRoutes = new Map<ReportPath, <T>(id?: T) => string>([
  [ReportPath.SalesPeriod, () => `${ModuleRoute.Report}/${ReportPath.SalesPeriod}`],
  [ReportPath.ProductExpiration, () => `${ModuleRoute.Report}/${ReportPath.ProductExpiration}`],
  [ReportPath.TopSellingProducts, () => `${ModuleRoute.Report}/${ReportPath.TopSellingProducts}`],
  [ReportPath.StockReplenishment, () => `${ModuleRoute.Report}/${ReportPath.StockReplenishment}`],
  [ReportPath.AccountsReceivable, () => `${ModuleRoute.Report}/${ReportPath.AccountsReceivable}`],
]);

export const getReportModuleRoutes = <T>(route: ReportPath, id?: T): string => {
  const routeFunction = ReportModuleRoutes.get(route);
  if (routeFunction) {
    return routeFunction(id);
  }
  throw new Error(`Route ${route} not found}`);
};
